import { z } from "zod";

export type QcBizResponder = z.infer<typeof QcBizResponderSchema>;
export const QcBizResponderSchema = z.object({
  tenant_id: z.number(),
  id: z.number(),
  name: z.string(),
});
